import { faArrowRotateLeft, faCalendar, faCalendarClock, faCalendarDay, faCheck, faX } from '@fortawesome/pro-light-svg-icons';
var statusMessages = new Map([
    ['CANCELED', faX],
    ['PENDING', faCalendarDay],
    ['POSTED', faCheck],
    ['PROCESSING', faCalendar],
    ['REJECTED', faArrowRotateLeft],
    ['SCHEDULED', faCalendarClock]
]);
export default statusMessages;
//# sourceMappingURL=status-messages.js.map